class PriceCalculator {
    constructor() {
        this.basePrice = 0;
        this.upsellPrices = TasacionesConf.upsell_prices || {};
    }

    updateStep3Price(priceElement) {
        if (!priceElement || typeof TasacionesConf === 'undefined') {
            return;
        }

        const priceWithoutDiscountElement = document.getElementById('tasaciones_funnel_price_without_discount');
        // console.log('Tasaciones Funnel Step 3 - PRICE UPDATE - priceWithoutDiscountElement: ', priceWithoutDiscountElement);
        let priceWithoutDiscount = undefined;
        if (priceWithoutDiscountElement) {
            priceWithoutDiscount = parseFloat(priceWithoutDiscountElement.getAttribute('data-tasaciones-price-without-discount'));
        }
        // console.log('Tasaciones Funnel Step 3 - PRICE UPDATE - priceWithoutDiscount: ', priceWithoutDiscount);

        let price = parseFloat(priceElement.getAttribute('data-tasaciones-price'));
        const priceUpsells4 = parseFloat(priceElement.getAttribute('data-tasaciones-price-upsells-step4'));
        price = price + priceUpsells4;
        
        if (priceWithoutDiscount !== undefined) {
            priceWithoutDiscount = priceWithoutDiscount + priceUpsells4;
        }

        // Nota simple del inmueble
        const tieneNotaSimple = document.querySelector('input[name="tiene_nota_simple"]:checked');
        if (tieneNotaSimple?.value === "la paga") {
            const notaSimpleCost = parseFloat(this.upsellPrices[2]?.price || 0);
            if (!isNaN(notaSimpleCost)) {
                price += notaSimpleCost;

                if (priceWithoutDiscount !== undefined) {
                    priceWithoutDiscount = priceWithoutDiscount + notaSimpleCost;
                }
            }
        }

        // Garaje
        const anadeGaraje = document.querySelector('input[name="anadir_garaje"]:checked');
        if (anadeGaraje?.value === "1") {
            const garajeCost = parseFloat(this.upsellPrices[3]?.price || 0);
            if (!isNaN(garajeCost)) {
                price += garajeCost;

                if (priceWithoutDiscount !== undefined) {
                    priceWithoutDiscount = priceWithoutDiscount + garajeCost;
                }
            }
            
            // Nota simple del garaje
            const tieneNotaSimpleGaraje = document.querySelector('input[name="tiene_nota_simple_garaje"]:checked');
            if (tieneNotaSimpleGaraje?.value === "la paga") {
                const notaSimpleGarajeCost = parseFloat(this.upsellPrices[5]?.price || 0);
                if (!isNaN(notaSimpleGarajeCost)) {
                    price += notaSimpleGarajeCost;

                    if (priceWithoutDiscount !== undefined) {
                        priceWithoutDiscount = priceWithoutDiscount + notaSimpleGarajeCost;
                    }
                }
            }
        }

        // Trastero
        const anadeTrastero = document.querySelector('input[name="anadir_trastero"]:checked');
        if (anadeTrastero?.value === "1") {
            const trasteroCost = parseFloat(this.upsellPrices[4]?.price || 0);
            if (!isNaN(trasteroCost)) {
                price += trasteroCost;

                if (priceWithoutDiscount !== undefined) {
                    priceWithoutDiscount = priceWithoutDiscount + trasteroCost;
                }
            }
            
            // Nota simple del trastero
            const tieneNotaSimpleTrastero = document.querySelector('input[name="tiene_nota_simple_trastero"]:checked');
            if (tieneNotaSimpleTrastero?.value === "la paga") {
                const notaSimpleTrasteroCost = parseFloat(this.upsellPrices[6]?.price || 0);
                if (!isNaN(notaSimpleTrasteroCost)) {
                    price += notaSimpleTrasteroCost;

                    if (priceWithoutDiscount !== undefined) {
                        priceWithoutDiscount = priceWithoutDiscount + notaSimpleTrasteroCost;
                    }
                }
            }
        }

        this.updatePriceDisplay(priceElement, price);
        // console.log('Tasaciones Funnel Step 3 - PRICE UPDATE - Final Price: ', price);
        
        if (priceWithoutDiscount !== undefined) {
            this.updatePriceDisplay(priceWithoutDiscountElement, priceWithoutDiscount, false);
            // console.log('Tasaciones Funnel Step 3 - PRICE UPDATE - Final Price Without Discount: ', priceWithoutDiscount);
        }
    }

    updateStep4Price(priceElement) {
        if (!priceElement || typeof TasacionesConf === 'undefined') {
            return;
        }

        const priceWithoutDiscountElement = document.getElementById('tasaciones_funnel_price_without_discount');
        // console.log('Tasaciones Funnel Step 3 - PRICE UPDATE - priceWithoutDiscountElement: ', priceWithoutDiscountElement);
        let priceWithoutDiscount = undefined;
        if (priceWithoutDiscountElement) {
            priceWithoutDiscount = parseFloat(priceWithoutDiscountElement.getAttribute('data-tasaciones-price-without-discount'));
        }
        // console.log('Tasaciones Funnel Step 3 - PRICE UPDATE - priceWithoutDiscount: ', priceWithoutDiscount);


        let price = parseFloat(priceElement.getAttribute('data-tasaciones-price'));
        const priceUpsells = parseFloat(priceElement.getAttribute('data-tasaciones-price-upsells-step3'));
        price = price + priceUpsells;

        if (priceWithoutDiscount !== undefined) {
            priceWithoutDiscount = priceWithoutDiscount + priceUpsells;
        }

        // Servicio urgente
        const tieneServicioUrgente = document.querySelector('input[name="tasacion_urgente"]:checked');
        if (tieneServicioUrgente?.value === "1") {
            const servicioUrgenteCost = parseFloat(this.upsellPrices[1]?.price || 0);
            if (!isNaN(servicioUrgenteCost)) {
                price += servicioUrgenteCost;

                if (priceWithoutDiscount !== undefined) {
                    priceWithoutDiscount = priceWithoutDiscount + servicioUrgenteCost;
                }
            }
        }

        this.updatePriceDisplay(priceElement, price);
        console.log('Tasaciones Funnel Step 4 - PRICE UPDATE - Final Price: ', price);

        if (priceWithoutDiscount !== undefined) {
            this.updatePriceDisplay(priceWithoutDiscountElement, priceWithoutDiscount, false);
            // console.log('Tasaciones Funnel Step 3 - PRICE UPDATE - Final Price Without Discount: ', priceWithoutDiscount);
        }
    }

    updateStep2PriceCatastro(priceElement, catastroPrice, catastroPriceWithoutDiscount, newSurface) {
        if (!priceElement) {
            console.error('updateStep2PriceCatastro: priceElement is null');
            return;
        }
        const priceWithoutDiscountElement = document.getElementById('tasaciones_funnel_price_without_discount');
        const surfaceElement = document.getElementById('tasaciones_funnel_surface');

        if (surfaceElement && newSurface !== undefined) {
            surfaceElement.textContent = `${newSurface} m²`;
        }
        
        this.updatePriceDisplay(priceElement, catastroPrice);

        if (catastroPriceWithoutDiscount !== undefined && priceWithoutDiscountElement) {
            this.updatePriceDisplay(priceWithoutDiscountElement, catastroPriceWithoutDiscount, false);
        }
    }

    updatePriceDisplay(priceElement, price, showTax = true) {
        if (!priceElement) {
            console.error('updatePriceDisplay: priceElement is null');
            return;
        }
        const taxType = (window.TasacionesConf && window.TasacionesConf.order && window.TasacionesConf.order.tipo_impuesto) || 'IVA';
        priceElement.innerHTML = new Intl.NumberFormat('es-ES', {
            style: 'currency',
            currency: 'EUR'
        }).format(price) + (showTax ? "<span class=\"tasaciones-text-sm tasaciones-ml-1\">+" + taxType + "</span>" : "");
    }
}

// Hacer la clase disponible globalmente
window.PriceCalculator = PriceCalculator;